module.exports = __webpack_public_path__ + "static/media/FreedomEdge-20ml.7815d9f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/FreedomEdge-20ml.png
// module id = 247
// module chunks = 0